import { css } from 'aphrodite';
import moment from 'moment';
import * as React from 'react';
import { IUser } from '../../../../../extViewmodels';
import { Button } from '../../../../../web/components-v2/Button';
import { Checkbox } from '../../../../../web/components-v2/Checkbox';
import { DateRangePicker } from '../../../../../web/components-v2/DateRangePicker';
import { Label } from '../../../../../web/components-v2/Label';
import { UserAutocomplete } from '../../../../../web/components/UserAutocomplete';
import { ExportIcon } from '../../../../../web/components/svgs/icons/ExportIcon';
import { IPrizeLogFilter } from '../../../../models/slotMachines';
import { styleSheet } from '../styles';

interface IProps {
	filter: IPrizeLogFilter;
	exportingCsv?: boolean;
	onChange?: (filter: IPrizeLogFilter) => void;
	onExport?: () => void;
}

const ISO_FORMAT = 'YYYY-MM-DD';

export const ListHeader: React.FC<IProps> = ({ filter: currentFilter, exportingCsv, onChange, onExport }) => {
	const dateFrom = currentFilter.date ? moment(currentFilter.date.start).format(ISO_FORMAT) : '';
	const dateTo = currentFilter.date ? moment(currentFilter.date.end).format(ISO_FORMAT) : '';

	const applyFilter = (patch: Partial<IPrizeLogFilter>) => {
		onChange?.({ ...currentFilter, ...patch });
	};

	const handleUserChange = (user: IUser | null) => applyFilter({ user });

	const handleDateChange = (from: string, to: string) => {
		const hasRange = Boolean(from) && Boolean(to);
		applyFilter({
			date: hasRange ? { end: moment(to, ISO_FORMAT).toDate(), start: moment(from, ISO_FORMAT).toDate() } : null,
		});
	};

	const handleUnpaidChange = (checked: boolean | 'indeterminate') => applyFilter({ prizePaid: checked === true });

	return (
		<div className={css(styleSheet.filter)}>
			<div className={css(styleSheet.filterUser)}>
				<UserAutocomplete
					ariaLabel='Filter by SDR'
					onChange={handleUserChange}
					placeholder='Filter by SDR'
					value={currentFilter.user ?? null}
				/>
			</div>
			<div className={css(styleSheet.filterDate)}>
				<DateRangePicker
					applyOnComplete={true}
					ariaLabel='Filter by date'
					from={dateFrom}
					numberOfMonths={1}
					onChange={handleDateChange}
					size='sm'
					to={dateTo}
				/>
			</div>
			<Label htmlFor='prizes-log-unpaid-only' styles={[styleSheet.unpaidLabel]}>
				<Checkbox
					checked={Boolean(currentFilter.prizePaid)}
					id='prizes-log-unpaid-only'
					onCheckedChange={handleUnpaidChange}
				/>
				Show unpaid only
			</Label>
			<span className={css(styleSheet.filterSpacer)} />
			<Button isLoading={exportingCsv} onClick={onExport} type='button' variant='secondary'>
				<ExportIcon fillColor='currentColor' />
				Export to CSV
			</Button>
		</div>
	);
};
